import { appStateWords, DeviceWord } from "./TechDeviceWords"
import { TechDeviceState, useTechClock, useTechDeviceState } from "../../core/TechLive"
import Icon from "../base/Icon"

interface IProps {
    techId?: string
    className?: string
    /** Where a row already carries its own icon. */
    noIcon?: boolean
}

/**
 * The word for how the app is running, or nothing to say: off the clock the phone is not
 * reporting, so whatever it last said is from whenever that was.
 */
export const appStateWord = (state?: TechDeviceState, onClock?: boolean): DeviceWord | undefined =>
    onClock && state?.appState ? appStateWords[state.appState] : undefined

/**
 * Whether the Rinvox app is open, minimized or closed on the technician's phone, as the app last
 * said — the first line under their name on the map's panel and drawer, because it is the first
 * thing that explains a dot gone quiet: a phone in a pocket keeps reporting, a closed app does not.
 */
export default function TechAppStateLabel(props: IProps) {

    const state = useTechDeviceState(props.techId)
    const clock = useTechClock(props.techId)
    const word = appStateWord(state, clock?.on)

    const tone = word?.tone ?? "gray-500"
    const text = word?.label ?? (clock?.on ? "App state not reported" : "App not reporting (off the clock)")
    const note = word?.note ?? (clock?.on ? "This app build does not say whether it is open." : "Off the clock, the app does not report.")

    return (
        <span className={`d-inline-flex align-items-center ${props.className ?? ""}`} title={note}>
            {!props.noIcon &&
                <span className="d-inline-flex justify-content-center me-2" style={{ width: 7, overflow: "visible" }}>
                    <Icon icon="mobile-screen" className={`text-${tone}`} size={11} />
                </span>
            }
            <span className={`fw-semibold text-${tone}`}>{text}</span>
        </span>
    )
}
